export default __webpack_public_path__ + "static/media/DSC_7432.67cd03bb.jpg";